module.exports = __webpack_public_path__ + "static/media/profile_page_example.2a960b8f.png";